import { Assets } from '../../../utils/assets';

export const SCIENCE_IN_COLLAPSED_STATE = 3;

export const SCIENCE_EXTERNAL_LINK = 'https://www.nature.com/articles/s42003-024-07026-3';

export const LITERATURE_LIST = [
  {
    title: 'Entrainment of neural oscillations as a modifiable substrate of attention.',
    description: 'Calderone, D. J., Lakatos, P., Butler, P. D. & Xavier Castellanos, F.  (2014)',
    link: 'https://www.sciencedirect.com/science/article/abs/pii/S1364661314000485',
  },
  {
    title:
      'Preferred stimulation levels in introverts and extroverts: Effects on arousal and performance.',
    description: 'Geen, R. G.  (1984)',
    link: 'https://psycnet.apa.org/record/1984-28698-001',
  },
  {
    title:
      'The differential distraction of background music on the cognitive test performance of introverts and extraverts.',
    description: 'Furnham, A. & Bradley, A.   (1997)',
    link: 'https://onlinelibrary.wiley.com/doi/abs/10.1002/(SICI)1099-0720(199710)11:5%3C445::AID-ACP472%3E3.0.CO;2-R',
  },
  {
    title:
      'Brain arousal regulation in adults with attention-deficit/hyperactivity disorder (ADHD). ',
    description: 'Strauß, M. et al. (2018)',
    link: 'https://www.sciencedirect.com/science/article/abs/pii/S016517811731644X',
  },
  {
    title:
      'Cortical activity patterns in ADHD during arousal, activation and sustained attention. ',
    description: 'Loo, S. K. et al.  (2009)',
    link: 'https://www.sciencedirect.com/science/article/abs/pii/S0028393209001638',
  },
  {
    title:
      'Top-down beta rhythms support selective attention via interlaminar interaction: a model.',
    description: 'Lee, J. H., Whittington, M. A. & Kopell, N. J. (2013)',
    link: 'https://journals.plos.org/ploscompbiol/article?id=10.1371/journal.pcbi.1003164',
  },
];

export const SCIENCE_LIST = [
  {
    title:
      'Rapid modulation in music supports attention in listeners with attentional difficulties',
    description:
      'Woods, KJP., Sampaio, G.,, James, T., Przysinda, E., Spencer, A.,Hewett, A., Spencer, A., Morillon, B., & Loui, P. (2024)',
    link: 'https://www.nature.com/articles/s42003-024-07026-3',
  },
  {
    title: 'Modulation in background music influences sustained attention',
    description: 'Woods, KJP., Hewett, A., Spencer, A., Morillon, B., & Loui, P. (2019)',
    link: 'https://arxiv.org/abs/1907.06909',
  },
  {
    title: 'Headphone screening to facilitate web-based auditory experiments',
    description: 'Woods, KJP., et al.  (2018)',
    link: 'https://link.springer.com/article/10.3758/s13414-017-1361-2',
  },
];

export const MEMBERS = [
  {
    name: 'Kevin JP Woods, PhD',
    position: 'director of science, brain.fm',
    img: Assets.images.scienceTeam.kevin,
    link: 'http://www.kevinjpwoods.com/',
  },
  {
    name: 'Psyche Loui, PhD',
    position: [
      'academic collaborator',
      'professor of music & Neuroscience northeastern university',
    ],
    img: Assets.images.scienceTeam.psyche,
    link: 'https://www.psycheloui.com/',
  },
  {
    name: 'Benjamin Morillon, PhD',
    position: [
      'scientific advisor',
      'Institute of Systems Neuroscience,  Aix-Marseille university',
    ],
    img: Assets.images.scienceTeam.benjamin,
  },
];
